/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class StandardActions {
}
StandardActions.LOGO_LINK = 'LOGO_LINK';
StandardActions.TITLE_LINK = 'TITLE_LINK';
StandardActions.HOME_LINK = 'HOME_LINK';
StandardActions.SIGN_IN = 'SIGN_IN';
StandardActions.SIGN_OUT = 'SIGN_OUT';
StandardActions.PROFILE = 'PROFILE';
StandardActions.REGISTER = 'REGISTER';
StandardActions.PRIVACY_LINK = "PRIVACY_LINK";
StandardActions.CONTACT_US_LINK = "CONTACT_US_LINK";
StandardActions.ABOUT_DELL_LINK = "ABOUT_DELL_LINK";
StandardActions.COPYRIGHT_LINK = "COPYRIGHT_LINK";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbmRhcmQtYWN0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvbWljcm8tZnJvbnRlbmRzL2FjdGlvbnMvc3RhbmRhcmQtYWN0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxlQUFlOztBQUNELHlCQUFTLEdBQUcsV0FBVyxDQUFDO0FBQ3hCLDBCQUFVLEdBQUcsWUFBWSxDQUFDO0FBQzFCLHlCQUFTLEdBQUcsV0FBVyxDQUFDO0FBRXhCLHVCQUFPLEdBQUcsU0FBUyxDQUFDO0FBQ3BCLHdCQUFRLEdBQUcsVUFBVSxDQUFDO0FBQ3RCLHVCQUFPLEdBQUcsU0FBUyxDQUFDO0FBQ3BCLHdCQUFRLEdBQUcsVUFBVSxDQUFDO0FBRXRCLDRCQUFZLEdBQUcsY0FBYyxDQUFDO0FBQzlCLCtCQUFlLEdBQUcsaUJBQWlCLENBQUM7QUFDcEMsK0JBQWUsR0FBRyxpQkFBaUIsQ0FBQztBQUNwQyw4QkFBYyxHQUFHLGdCQUFnQixDQUFDIn0=